const USERS_URL = process.env.REACT_APP_N8N_USERS_URL;
const SECRET    = process.env.REACT_APP_N8N_SECRET;

const authHeaders = { 'x-api-key': SECRET || '' };

const parseJSON = async (res) => {
  const text = await res.text();
  if (!text || !text.trim()) throw new Error(`الخادم أعاد استجابة فارغة (${res.status})`);
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`استجابة غير صالحة من الخادم: ${text.slice(0, 120)}`);
  }
};

const usersService = {
  getAll: async () => {
    if (!USERS_URL) throw new Error('REACT_APP_N8N_USERS_URL غير مضبوط في ملف .env');
    const res = await fetch(USERS_URL, { headers: authHeaders });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await parseJSON(res);
    if (json.error) throw new Error(json.error);
    return json;
  },
};

export default usersService;
